'use strict';

var React = require('react');
var useProps$1 = require('../html/use-props.cjs');
var useProps = require('../svg/use-props.cjs');
var filterProps = require('./utils/filter-props.cjs');
var isSvgComponent = require('./utils/is-svg-component.cjs');
var isMotionValue = require('../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');

function useRender(Component, props, ref, { latestValues, }, isStatic, forwardMotionProps = false) {
    const useVisualProps = isSvgComponent.isSVGComponent(Component)
        ? useProps.useSVGProps
        : useProps$1.useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = filterProps.filterProps(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== React.Fragment ? { ...filteredProps, ...visualProps, ref } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */
    const { children } = props;
    const renderedChildren = React.useMemo(() => (isMotionValue.isMotionValue(children) ? children.get() : children), [children]);
    return React.createElement(Component, {
        ...elementProps,
        children: renderedChildren,
    });
}

exports.useRender = useRender;
//# sourceMappingURL=use-render.cjs.map
